import { ServerInterface } from "../interfaces/Server.interface";
import { BLANK_ORGANIZATION } from "./organization";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_SERVER: ServerInterface = {
  id: null,
  ip: "",
  name: "",
  syncSched: "",
  orgId: null,
  recordSyncSize: 0,
  org: BLANK_ORGANIZATION,
  channels: [],
  nextRecordsSyncRun: "",
  nextServerSyncRun: "",
  fbEnabled: true,
  lastSuccessfulQuestDbSyncRun: null,
  nextQuestDbSyncRun: null,
  syncQuestDbSched: "",
  active: true,
};
